// ==============================================
// ==================Import======================
// ==============================================

// =================Component================
import Carousel from 'react-bootstrap/Carousel';

// ==================Hooks===================
import { useSelector } from 'react-redux';

// ==================Style&IMG===================
import './style.scss';

function CarouselTimeSeries() {
// ==================Hooks===================

  const timeseries = useSelector((state) => state.metadata.data.dataDoi.timeseries);

  return (
    <div className="carousel_container">
      <div className="panel-heading">
        <h4 className="panel-title">Time Series</h4>
      </div>
      <Carousel slide={false} data-bs-theme="dark" interval={null} className="carousel">
        {timeseries.map((el) => (
          <Carousel.Item key={el.id} className="carousel_item">
            <p className="carousel_image--text">{el.text}</p>
            <img className="d-block w-100 carousel_image" src={el.image} alt="No timeserie available from this Analysis/Combination Center" />
          </Carousel.Item>
        ))}
      </Carousel>
    </div>
  );
}

export default CarouselTimeSeries;
